<template>
        <div class="returnTopStyle" @click="toTop">
            <img src="../assets/icon5.png" />
        </div>
</template>
<script>
    export default {
        name: 'returnTop',
        data() {
            return {

            }
        },
        mounted() {
        },
        // 方法体
        methods: {
            toTop() {
                window.scrollTo({
                    top: 0, // 滚动到页面顶部
                    behavior: 'smooth' // 平滑滚动
                });
            }
        },

    }
</script>
<style scoped>
    .returnTopStyle {
        width: 5vw;
        height: 5vw;
        position: fixed;
        bottom: 10vw;
        right: 1vw;
        width: 2vw;
        height: 2vw;
        z-index: 999999999999999999999999999999999999;
        cursor: pointer;
    }
</style>